import React from "react"
import { styled } from "../../../../stitches.config";

const HardcoverImageBanner = ({ blockData }) => {
    const url = blockData.url.replace('0,0,0,0', '823,847,1,0')
    return <ImageBanner src={url} />;
}

const ImageBanner = styled("img", {
    maxWidth: "calc(100% - 60px)",
    height: "auto",
    "@media (min-width: 992px)": {
        maxWidth: "calc(100% - 115px)"
    }
});

export default HardcoverImageBanner